import {storage} from '@/utils/storage'

export default {
  namespaced: true,
  state: {
    loginData: {}
  },
  mutations: {
  },
  actions: {
    DO_LOGIN ({ commit, dispatch }, params) {
      return window.myVue.$api.doLogin({
        data: params
      }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    LOG_OUT () {
      return window.myVue.$api.logOut().then((res) => {
        storage.set('tokenError', true)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    CHANGE_PWD ({commit, dispatch}, params) {
      return window.myVue.$api.changePwd({
        data: params
      }).then((res) => {
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/login/store/index.js